$(window).on('load',function(){

  function validateEmail(email) {
      // Regular expression for validating an email
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailPattern.test(email);
  }
  
  $("form[data-id='50787']").on('submit',function(){       /* contact us form */
     let formId = $(this).attr('data-id');
     let brand = $(`#${formId}-select-4`).val();
     let firstName = $(`#${formId}-name-1`).val();
     let lastName = $(`#${formId}-name-2`).val();
     let postalCode = $(`#${formId}-text-1`).val();
     let email = $(`#${formId}-email-1`).val();
     let phone = $(`#${formId}-phone-1`).val();
     let serialNumber = $(`#${formId}-text-7`).val();
     //Sitecode then concatenate "Product Quesiton"
     let questionIsRegarding = ($(`#${formId}-select-4`).val());
     let question = $(`#${formId}-textarea-1`).val();
     let leadType = "Question";
     let siteCode = "FAF";
     let modelNumber = $(`#${formId}-text-5`).val();
     let address1 = $(`#${formId}-text-2`).val();
     let address2 = $(`#${formId}-text-3`).val();
     let city = $(`#${formId}-text-4`).val();
     let state = $(`#${formId}-select-1`).val();
     let brandCodeshort;

    
     if(brand == 'Harman Stoves'){
        brandCodeshort = 'HAR';
     }else if(brand == 'Quadra-Fire'){
        brandCodeshort = 'QDF';
     }else if(brand == 'Vermont Castings'){
        brandCodeshort = 'VMT';
     }else if(brand == 'Forge & Flame Electric'){
       brandCodeshort = 'FFE';
     }else if(brand == 'PelPro'){
       brandCodeshort = 'PEL';
     }else if(brand == 'WoodPro'){
       brandCodeshort = 'WPS';
     }
     else{}


     // We need to test for the null condition on the page load.
     if(questionIsRegarding != null){
       questionIsRegarding = questionIsRegarding.concat(" - Product Question");
     }
    

      // New zipcode validation which only allows a valid US zipcode or a valid Canadian postal code
        let usRegex = /^[0-9]{5}(?:-[0-9]{4})?$/; // US ZIP code format
        let canadaRegex = /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1}[ -]?\d{1}[A-Z]{1}\d{1}$/i; // Canadian postal code format
        if ((postalCode.length <= 10 && usRegex.test(postalCode)) || (postalCode.length <= 10 && canadaRegex.test(postalCode))) {
            // valid code
        } else {
          var getPostalCode = document.getElementById(`${formId}-text-1`); 
          getPostalCode.value = "";
          postalCode = ""; 
          alert("Invaild zip or postal code");
        }    

      // check total character length of firstname and lastname fields
        let totalCharacters = firstName.length + lastName.length;
        if(totalCharacters > 79){
          alert("Combined length of first and last name cannot exceed 79 characters");
          return false;
        }

      // Email format validation
        if (!validateEmail(email)) {
           email = "";
        }    
    
      let formData = {
         Brands:brandCodeshort,
         Leadtype : leadType,
         Sitecode : siteCode,
         Firstname: firstName, 
         Lastname : lastName, 
         PostalCode: postalCode, 
         Email : email, 
         SerialNumber : serialNumber, 
         QuestionIsRegarding : questionIsRegarding, 
         ModelNumber : modelNumber, 
         Phone : phone,
         Question: question,
         Address1:address1,
         Address2:address2,
         City:city,
         State:state
      }
      let formJSON = JSON.stringify(formData)
      console.log (formJSON)

      if(!firstName == "" && !lastName == "" && !email == "" && !postalCode == ""  && !question == "" && !brandCodeshort == "" && questionIsRegarding != null){
          $.ajax({
            url: "https://brandography-dev.dreamhosters.com/contact_us.php",
            type: "POST",
            dataType: "json",
            data: formJSON,
            contentType: "application/json",
            success: function(response) {
              console.log("Data sent successfully!");
              console.log(response);
              window.location.href='/pages/thank-you-contact-us';
            },
            error: function(error) {
               console.log(error);
            }
          }); 
      }else{
        console.log("Please fill in the mandatory fields");
             console.log("this is the market value:");
            
      }
  });

  $("form[data-id='43889']").on('submit',function(){       /* request a quote form */
     let formId = $(this).attr('data-id');
     let firstName = $(`#${formId}-text`).val();
     let lastName = $(`#${formId}-text-2`).val();
     let postalCode = $(`#${formId}-text-6`).val();
     let email = $(`#${formId}-email`).val();
     let phone = $(`#${formId}-phone`).val();
     let contactMethod = $(this).find(`input[name="radio-1"]:checked`).val();
     let brand = $(`#${formId}-select`).val();
     let product = $(`#${formId}-select-2`).val();
     let projectComments = $(`#${formId}-textarea`).val();
     let leadType = "Quote Request";
     let hhtCampaignID = "HHTC126894QUT";
     let leadSource = "FAF-WebForm";
     let siteCode = "FAF";
     let rawURL = "https://forgenflame.com/pages/get-a-quote";
     let brandCodeshort;

     if(brand == 'Harman'){
        brandCodeshort = 'HAR';
     }else if(brand == 'Quadra-Fire'){
        brandCodeshort = 'QDF';
     }else if(brand == 'Vermont Castings'){
        brandCodeshort = 'VMT';
     }else if(brand == 'Forge & Flame Electric'){
        brandCodeshort = 'FFE';
     }else{}    


      // New zipcode validation which only allows a valid US zipcode or a valid Canadian postal code
        let usRegex = /^[0-9]{5}(?:-[0-9]{4})?$/; // US ZIP code format
        let canadaRegex = /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1}[ -]?\d{1}[A-Z]{1}\d{1}$/i; // Canadian postal code format
        if ((postalCode.length <= 10 && usRegex.test(postalCode)) || (postalCode.length <= 10 && canadaRegex.test(postalCode))) {
            // valid code
        } else {
          var getPostalCode2 = document.getElementById(`${formId}-text-6`); 
          getPostalCode2.value = "";
          postalCode = "";  
          alert("Invaild zip or postal code");
        }
       
     let formData = {
        Leadtype:leadType,
        HHTCampaignID:hhtCampaignID,
        Leadsource:leadSource,
        Sitecode: siteCode,
        PostalCode:postalCode,
        Brands:brandCodeshort,
        Firstname:firstName,
        Lastname:lastName,
        PreferredConsultationMethod:contactMethod,
        Comments:projectComments, 
        Phone:phone, 
        Email:email, 
        RawUrl:rawURL
     }  

     let formJSON = JSON.stringify(formData);
     console.log (formJSON);
     if(!firstName == "" && !lastName == "" && !email == "" && !postalCode == "" && !brandCodeshort == ""){
        $.ajax({
          url: "https://brandography-dev.dreamhosters.com/request_quote.php",
          type: "POST",
          dataType: "json",
          data: formJSON,
          contentType: "application/json",
          success: function(response) {
            console.log("Data sent successfully!!");
            console.log(response);
            window.location.href='/pages/thank-you-request-a-quote';
          },
          error: function(error) {
             console.log(error);
          }
        });  
     }else{
        console.log("Please fill mandatory fields");
     }
  }); 

   $("form[data-id='76357']").on('submit',function(){       /* New request a quote form (promo form) */
     let formId = $(this).attr('data-id');
     let firstName = $(`#${formId}-text`).val();
     let lastName = $(`#${formId}-text-2`).val();
     let postalCode = $(`#${formId}-text-6`).val();
     let email = $(`#${formId}-email`).val();
     let phone = $(`#${formId}-phone`).val();
     let contactMethod = $(this).find(`input[name="radio-1"]:checked`).val();
     let brand = $(`#${formId}-select`).val();
     let product = $(`#${formId}-select-2`).val();
     let projectComments = $(`#${formId}-textarea`).val();
     let leadType = "Coupon Request";
     let hhtCampaignID = "HHTC164474CPN";
     let leadSource = "FAF-WebForm";
     let siteCode = "FAF";
     let rawURL = "https://forgenflame.com/pages/save-on-heat";
     let brandCodeshort;

     if(brand == 'Harman'){
        brandCodeshort = 'HAR';
     }else if(brand == 'Quadra-Fire'){
        brandCodeshort = 'QDF';
     }else if(brand == 'Vermont Castings'){
        brandCodeshort = 'VMT';
     }else if(brand == 'Forge & Flame Electric'){
        brandCodeshort = 'FFE';
     }else{}    


      // New zipcode validation which only allows a valid US zipcode
        let usRegex = /^[0-9]{5}(?:-[0-9]{4})?$/; // US ZIP code format
       // let canadaRegex = /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1}[ -]?\d{1}[A-Z]{1}\d{1}$/i; // Canadian postal code format
        if(postalCode.length <= 10 && usRegex.test(postalCode)) {
            // valid code
        } else {
          var getPostalCode2 = document.getElementById(`${formId}-text-6`); 
          getPostalCode2.value = "";
          postalCode = "";  
          alert("Invaild zip or postal code");
        }
       
     let formData = {
        Leadtype:leadType,
        HHTCampaignID:hhtCampaignID,
        Leadsource:leadSource,
        Sitecode: siteCode,
        PostalCode:postalCode,
        Brands:brandCodeshort,
        Firstname:firstName,
        Lastname:lastName,
        PreferredConsultationMethod:contactMethod,
        Comments:projectComments, 
        Phone:phone, 
        Email:email, 
        RawUrl:rawURL
     }  

     let formJSON = JSON.stringify(formData);
     console.log (formJSON);
     if(!firstName == "" && !lastName == "" && !email == "" && !postalCode == "" && !brandCodeshort == ""){
        $.ajax({
          url: "https://brandography-dev.dreamhosters.com/new-request-quote.php",
          type: "POST",
          dataType: "json",
          data: formJSON,
          contentType: "application/json",
          success: function(response) {
            console.log("Data sent successfully!!");
            console.log(response);
            window.location.href='/';
          },
          error: function(error) {
             console.log(error);
          }
        });  
     }else{
        console.log("Please fill mandatory fields");
     }
  }); 
})